<div>
    <span (click)="signout()">{{userShortcut}}</span>
</div>
